<script>
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import OnboardingView from '../OnboardingView.vue';
import EmptyStateMessage from './EmptyStateMessage.vue';

export default {
  components: {
    OnboardingView,
    EmptyStateMessage,
  },
  props: {
    // ConversationBox still passes this. Kept so it does not leak to the DOM.
    // eslint-disable-next-line vue/no-unused-properties
    isOnExpandedLayout: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isAdmin } = useAdmin();

    return {
      isAdmin,
    };
  },
  computed: {
    ...mapGetters({
      inboxesList: 'inboxes/getInboxes',
      uiFlags: 'inboxes/getUIFlags',
      loadingChatList: 'getChatListLoadingStatus',
    }),
    loadingIndicatorMessage() {
      if (this.uiFlags.isFetching) {
        return this.$t('CONVERSATION.LOADING_INBOXES');
      }
      return this.$t('CONVERSATION.LOADING_CONVERSATIONS');
    },
    isLoading() {
      return this.uiFlags.isFetching || this.loadingChatList;
    },
    showAgentWithoutInbox() {
      return !this.isLoading && !this.inboxesList.length && !this.isAdmin;
    },
    emptyClassName() {
      if (this.isLoading || this.showAgentWithoutInbox) {
        return 'flex-1 min-w-0 px-0 flex flex-col items-center justify-center h-full bg-n-surface-1';
      }
      return 'h-full overflow-auto w-full bg-n-background';
    },
  },
};
</script>

<template>
  <div :class="emptyClassName">
    <woot-loading-state v-if="isLoading" :message="loadingIndicatorMessage" />
    <EmptyStateMessage
      v-else-if="showAgentWithoutInbox"
      :message="$t('CONVERSATION.NO_INBOX_AGENT')"
    />
    <OnboardingView v-else />
  </div>
</template>
